// extracted by mini-css-extract-plugin
export var desktop2 = "Grid-module--desktop2--6cac2";
export var desktop3 = "Grid-module--desktop3--7e826";
export var desktop4 = "Grid-module--desktop4--2f2ff";
export var desktop5 = "Grid-module--desktop5--3c0a5";
export var mobile2 = "Grid-module--mobile2--82844";
export var mobile3 = "Grid-module--mobile3--538c4";
export var mobile4 = "Grid-module--mobile4--c683c";
export var mobileLg2 = "Grid-module--mobileLg2--96528";
export var mobileLg3 = "Grid-module--mobileLg3--2753b";
export var mobileLg4 = "Grid-module--mobileLg4--18fb2";
export var tablet2 = "Grid-module--tablet2--871ac";
export var tablet3 = "Grid-module--tablet3--1941a";
export var tablet4 = "Grid-module--tablet4--806a3";
export var tablet5 = "Grid-module--tablet5--b85d8";
export var wrapper = "Grid-module--wrapper--52216";